(function () {
  'use strict';

  // ===== HORIZONTAL CAROUSELS =====
  function wireCarousel(viewport, trackSel, slideSel, gap) {
    const track = viewport.querySelector(trackSel);
    const prev = viewport.querySelector('button[data-prev]');
    const next = viewport.querySelector('button[data-next]');
    if (!track || !prev || !next) return;

    const scrollByOneSlide = (direction) => {
      const slide = track.querySelector(slideSel);
      if (!slide) return;
      const distance = slide.getBoundingClientRect().width + gap;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByOneSlide(-1));
    next.addEventListener('click', () => scrollByOneSlide(1));
  }

  function initGallery() {
    const viewport = document.querySelector('[data-ruhl-gallery]');
    if (!viewport) return;
    const prev = viewport.querySelector('[data-ruhl-gallery-prev]');
    const next = viewport.querySelector('[data-ruhl-gallery-next]');
    if (prev) prev.setAttribute('data-prev', '');
    if (next) next.setAttribute('data-next', '');
    wireCarousel(viewport, '[data-ruhl-gallery-track]', '.ruhl-gallery__slide', 16);
  }

  function initMostLoved() {
    const viewport = document.querySelector('[data-ruhl-most-loved]');
    if (!viewport) return;
    const prev = viewport.querySelector('[data-ruhl-most-loved-prev]');
    const next = viewport.querySelector('[data-ruhl-most-loved-next]');
    if (prev) prev.setAttribute('data-prev', '');
    if (next) next.setAttribute('data-next', '');
    wireCarousel(viewport, '[data-ruhl-most-loved-track]', '.ruhl-most-loved__slide', 24);
  }

  // ===== UV INDEX =====
  const NICE_LAT = 43.695;
  const NICE_LON = 7.265;
  const UV_CACHE_KEY = 'ruhl-plage-uv';
  const UV_CACHE_TTL_MS = 30 * 60 * 1000;

  function severityFor(uv) {
    if (uv <= 2) return 'low';
    if (uv <= 5) return 'moderate';
    if (uv <= 7) return 'high';
    if (uv <= 10) return 'very_high';
    return 'extreme';
  }

  // Display copy. Hardcoded English here as a safety net — the locale
  // file already has translations, but the JSON isn't reachable from
  // client-side JS without rendering it via Liquid first. Keeping these
  // in sync with locales/en.default.json#ruhl_plage.uv.{severity,advice}.
  function uvCopy(severity) {
    const fallback = {
      low:        { label: 'Low',        advice: 'No protection needed for most people.' },
      moderate:   { label: 'Moderate',   advice: 'Some protection required — wear sunscreen.' },
      high:       { label: 'High',       advice: 'Protection essential — sunscreen, hat, shade.' },
      very_high:  { label: 'Very High',  advice: 'Extra protection — limit midday exposure.' },
      extreme:    { label: 'Extreme',    advice: 'Avoid sun exposure between 10am and 4pm.' }
    };
    return fallback[severity];
  }

  function readUVCache() {
    try {
      const raw = localStorage.getItem(UV_CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.t !== 'number' || typeof parsed.v !== 'number') return null;
      if (Date.now() - parsed.t > UV_CACHE_TTL_MS) return null;
      return parsed.v;
    } catch (_) { return null; }
  }

  function writeUVCache(value) {
    try {
      localStorage.setItem(UV_CACHE_KEY, JSON.stringify({ t: Date.now(), v: value }));
    } catch (_) {}
  }

  async function fetchUV() {
    const cached = readUVCache();
    if (cached !== null) return cached;
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${NICE_LAT}&longitude=${NICE_LON}&current=uv_index&timezone=Europe%2FParis`;
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) throw new Error(`UV API ${res.status}`);
    const data = await res.json();
    const raw = data && data.current && typeof data.current.uv_index === 'number' ? data.current.uv_index : null;
    if (raw === null) throw new Error('UV API: missing field');
    const value = Math.max(0, Math.min(11, Math.round(raw)));
    writeUVCache(value);
    return value;
  }

  function renderUV(value) {
    const root = document.querySelector('[data-ruhl-uv]');
    if (!root) return;
    const live = root.querySelector('[data-ruhl-uv-live]');
    const valueEl = root.querySelector('[data-ruhl-uv-value]');
    const severityEl = root.querySelector('[data-ruhl-uv-severity]');
    const adviceEl = root.querySelector('[data-ruhl-uv-advice]');
    const scaleItems = root.querySelectorAll('[data-ruhl-uv-scale] [data-uv]');

    const severity = severityFor(value);
    const copy = uvCopy(severity);

    valueEl.textContent = value >= 11 ? '11+' : String(value);
    severityEl.textContent = copy.label;
    severityEl.setAttribute('data-severity', severity);
    adviceEl.textContent = copy.advice;

    scaleItems.forEach(item => item.classList.toggle(
      'is-active',
      Number(item.dataset.uv) === Math.min(value, 11)
    ));

    live.hidden = false;
  }

  function showUVFallback() {
    const root = document.querySelector('[data-ruhl-uv]');
    if (!root) return;
    const cta = root.querySelector('[data-ruhl-uv-fallback-cta]');
    if (cta) cta.hidden = false;
  }

  async function initUV() {
    if (!document.querySelector('[data-ruhl-uv]')) return;
    try {
      const value = await fetchUV();
      renderUV(value);
    } catch (err) {
      console.warn('[ruhl-plage] UV index unavailable:', err);
      showUVFallback();
    }
  }

  // ===== FINALE VIDEO (autoplay when in viewport, pause when out) =====
  function initFinaleVideo() {
    const video = document.querySelector('[data-ruhl-finale-video]');
    if (!video || !('IntersectionObserver' in window)) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => { /* autoplay blocked; ignore */ });
          }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25 });
    obs.observe(video);
  }

  // ===== FADE-UP ON SCROLL =====
  function initFadeUp() {
    const els = document.querySelectorAll('[data-fade-up]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(el => obs.observe(el));
  }

  // ===== INIT =====
  // Each init is isolated: a throw in one must not stop the others. initFadeUp
  // runs last of five, so before this any earlier failure blanked the page.
  function run(name, fn) {
    try { fn(); } catch (e) { console.error('[ruhl-plage] ' + name + ' failed:', e); }
  }
  function init() {
    run('initGallery', initGallery);
    run('initMostLoved', initMostLoved);
    run('initUV', initUV);
    run('initFinaleVideo', initFinaleVideo);
    run('initFadeUp', initFadeUp);
  }

  // Opt into the hidden state only now that the script is running. If this file
  // never loads or throws before this line, the CSS leaves the content visible.
  document.documentElement.classList.add('js-fade-ready');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
